import React, {useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import {baseUrl} from "./Univ.js";
function PatientIPSearch({
                             onSelect, selectedPatient = null
                         }) {
    const [searchTerm, setSearchTerm] = useState("");
    const [patients, setPatients] = useState([]);
    const [loading, setLoading] = useState(false);
    const searchPatient = () => {
        if (!searchTerm.trim()) {
            return;
        }
        setLoading(true);
        axios.get(`${baseUrl}ip-pat-search/?search=${encodeURIComponent(searchTerm)}`)
            .then(response => {
                setPatients(Array.isArray(response.data) ? response.data : []);
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            });
    };
    const selectPatient = (row) => {
        const patient = row?.pat || {};
        onSelect({
            ip_record_id: row?.id || "",
            ip_id: row?.ip_id || row?.ip || "",
            pat_id: patient?.pat_id || "",
            patient: patient?.patient || "",
            mobile: patient?.mobile || "",
            address: patient?.address1 || "",
            ward: row?.ward || row?.ward_name || "",
            bed_no: row?.bed_no || row?.bed || ""
        });
        setPatients([]);
        setSearchTerm(patient?.patient || patient?.pat_id || row?.ip_id || "");
    };
    const columns = [{
        field: "ip_id", headerName: "IP ID", width: 140
    }, {
        field: "pat_id", headerName: "Patient ID", width: 150, renderCell: params => {
            return (<span>
                        {params.row?.pat?.pat_id || ""}
                    </span>);
        }
    }, {
        field: "patient", headerName: "Patient", width: 200, renderCell: params => {
            return (<span>
                        {params.row?.pat?.patient || ""}
                    </span>);
        }
    }, {
        field: "mobile", headerName: "Mobile", width: 130, renderCell: params => {
            return (<span>
                        {params.row?.pat?.mobile || ""}
                    </span>);
        }
    }, {
        field: "address", headerName: "Address", width: 250, renderCell: params => {
            return (<span>
                        {params.row?.pat?.address1 || ""}
                    </span>);
        }
    }, {
        field: "select", headerName: "Action", width: 100, sortable: false, renderCell: params => {
            return (<button
                type="button"
                className="btn btn-success btn-sm"
                onClick={() => selectPatient(params.row)}
            >
                Select
            </button>);
        }
    }];
    return (<div className="card mb-3">

        <div className="card-header">

            <strong>
                Patient / IP Search
            </strong>

        </div>

        <div className="card-body">

            <div className="row">

                <div className="col-md-10">

                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search Patient ID / IP ID / Name / Mobile"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === "Enter") {
                                searchPatient();
                            }
                        }}
                    />

                </div>

                <div className="col-md-2">

                    <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={searchPatient}
                    >
                        Search
                    </button>

                </div>

            </div>

            {patients.length > 0 && (<div className="mt-3">

                <DataGrid
                    autoHeight
                    rows={patients}
                    columns={columns}
                    loading={loading}
                    getRowId={row => row.id}
                    slots={{
                        toolbar: GridToolbar
                    }}
                    pageSizeOptions={[10, 25, 50]}
                />

            </div>)}

            {selectedPatient && (<div className="alert alert-success mt-3">

                <strong>
                    Selected Patient:
                </strong>

                {" "}

                {selectedPatient.patient}

                {" | Patient ID: "}

                {selectedPatient.pat_id}

                {" | IP ID: "}

                {selectedPatient.ip_id}

            </div>)}

        </div>

    </div>);
}
export default PatientIPSearch;